import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Kpimaster } from '../models/commission/kpimaster.model';
import { HttpClient } from '@angular/common/http';
import { appConfig, AuthGaurdService } from './auth-gaurd.service';
import { Observable, of, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { LoggerService } from './logger.service';
import { CustomHttpRespone } from '../models/customhttpresponse/custom-http-response';

@Injectable({
  providedIn: 'root'
})
export class KpimasterService {

  private host = environment.apiUrl + "commission/kpimaster";
  public loggedinUser: string = '';
  private cache: any = null; // Store cached data

  constructor(private http: HttpClient, private logger: LoggerService, private authGaurdService: AuthGaurdService) {
    this.loggedinUser = this.authGaurdService.loginUser();
    if (this.loggedinUser == "" || this.loggedinUser == null) {
      this.loggedinUser = "NA"
    } else {
      this.loggedinUser = this.authGaurdService.loginUser();
    }
  }


  // clearCache() {
  //   console.log("clearCache() Called");
  //   this.cache = null; // Reset cached data
  // }

  public getKpiActiveList(): Observable<Kpimaster[]> {
    // console.log("Service getKpiActiveList() before");
    // // Check if the response is already cached
    // if (!forceRefresh && this.cache) {
    //   return of(this.cache); // Return cached response as an observable
    // }
    // console.log("Service getKpiActiveList() after");

    return this.http.get<Kpimaster[]>(`${this.host}/getkpiactivelist`);
  }

  public getActiveKpis(): Observable<Kpimaster[]> {
    return this.http.get<Kpimaster[]>(`${this.host}/getactivekpis`);
  }

  public getPositionsValues(kpiid: number, effective_date: Date): Observable<Kpimaster[]> {
    return this.http.get<Kpimaster[]>(`${this.host}/getpositionsvalues` + '/' + kpiid + '/' + effective_date);
  }

  public getDependKpis(kpiid: number, effective_date: Date): Observable<Kpimaster[]> {
    return this.http.get<Kpimaster[]>(`${this.host}/getdependkpis` + '/' + kpiid + '/' + effective_date);
  }

  public getSelectedProducts(kpiid: number, effective_date: Date): Observable<Kpimaster[]> {
    return this.http.get<Kpimaster[]>(`${this.host}/getselectedproducts` + '/' + kpiid + '/' + effective_date);
  }

  public getActiveKpisByDate(effective_date: Date): Observable<Kpimaster[]> {
    return this.http.get<Kpimaster[]>(`${this.host}/getkpiactivelistbydate` + '/' + effective_date);
  }

  public getExcelKpiActiveList(): Observable<Kpimaster[]> {
    return this.http.get<Kpimaster[]>(`${this.host}/getexcelkpiactivelist`);
  }

  public getKPICalc(): Observable<Kpimaster[]> {
    return this.http.get<Kpimaster[]>(`${this.host}/getkpicalc`);
  }

  public createKPI(createKpiModel: Kpimaster): Observable<CustomHttpRespone> {
    return this.http.post<CustomHttpRespone>(`${this.host}/createkpi`, createKpiModel);
  }

  public updateKPI(kpiMasterModel: Kpimaster): Observable<CustomHttpRespone> {
    return this.http.post<CustomHttpRespone>(`${this.host}/updatekpi`, kpiMasterModel);
  }

  public insertKPI(formData: FormData): Observable<CustomHttpRespone> {
    return this.http.post<CustomHttpRespone>(`${this.host}/insertkpi`, formData);
  }



  public deleteProduct(id: number): Observable<CustomHttpRespone> {
    return this.http.delete<CustomHttpRespone>(`${this.host}/deleteproduct/${id}`);
  }


  public updateKpiStatusToActive(Kpimaster: Kpimaster[]): Observable<Kpimaster> {
    return this.http.put<Kpimaster>(`${this.host}/updatekpistatustoactive`, Kpimaster);
  }


  public updateKpiStatusToInactive(Kpimaster: Kpimaster[]): Observable<Kpimaster> {
    return this.http.put<Kpimaster>(`${this.host}/updatekpistatustoinactive`, Kpimaster);
  }


  public getAdminConfigData(): Observable<Kpimaster[]> {
    return this.http.get<Kpimaster[]>(`${this.host}/getkpitypeonelist`);
  }


  public getComboString(): Observable<Kpimaster[]> {
    return this.http.get<Kpimaster[]>(`${this.host}/getcombostringslist`);
  }


  public getDependentKpis(): Observable<Kpimaster[]> {
    return this.http.get<Kpimaster[]>(`${this.host}/getdependkpisdropdown`);
  }

  public getChargebackDependentKpis(effective_date: any, kpiid: any): Observable<Kpimaster[]> {
    return this.http.get<Kpimaster[]>(`${this.host}/getchargebackdependentkpisList` + '/' + kpiid + '/' + effective_date);
  }


  public getKpiTypeTwo(): Observable<Kpimaster[]> {
    return this.http.get<Kpimaster[]>(`${this.host}/getkpitypetwolist`);
  }

  public getProductTypes(): Observable<Kpimaster[]> {
    return this.http.get<Kpimaster[]>(`${this.host}/getproducts`);
  }

  public getProTypes(kpiid: number, effective_date: Date): Observable<Kpimaster[]> {
    return this.http.get<Kpimaster[]>(`${this.host}/getprotypes` + '/' + kpiid + '/' + effective_date);
  }

  public getCats(kpiid: number, proType: string, effective_date: Date): Observable<Kpimaster[]> {
    return this.http.get<Kpimaster[]>(`${this.host}/getcats` + '/' + kpiid + '/' + proType + '/' + effective_date);
  }

  public getPros(kpiid: number, proType: string, cat: string, effective_date: Date): Observable<Kpimaster[]> {
    return this.http.get<Kpimaster[]>(`${this.host}/getpros` + '/' + kpiid + '/' + proType + '/' + cat + '/' + effective_date);
  }

  public handleError(error: { error: { message: string; }; status: any; message: any; }) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    window.alert(errorMessage);
    return throwError(errorMessage);
  }
}



